import React from 'react';
import { Label, FormGroup, Row, Col, Form, FormText} from 'reactstrap';
import SelectCreatableListComponent from "../utils/selectCreatableList";
import SelectListComponent from "../utils/selectList";
 import moment from "moment/moment";
import DatePicker from 'react-datepicker';
// import DateSelector from '../utils/dateSelector';

import 'react-datepicker/dist/react-datepicker.css';
const InitiateForm = ({componentErrorMessages, FlightNumbers, airports, airlines, categories, selectedCategory, AirlineId, FlightNumber, StartFlightDate, EndFlightDate, DepartureAirportId, onSubmit, handleSelectChange, handleChange, handleAirlineChange, handleFlightChange, handleDateChange}) => {
    return (
        <div className={'mb-3'}>
            <Form onSubmit={onSubmit}>
                <Row>
                    <Col sm="12">
                        <FormGroup className={"mb-3 " + (componentErrorMessages.selectedCategory ? 'has-danger' : '')}>
                            <Label>Select Type</Label>
                            <SelectListComponent data={categories} valueKey='Id' textField='Name' selectValue={selectedCategory} onValueChange={(payload) => handleSelectChange(payload, 'Id', 'selectedCategory')}/>
                            {componentErrorMessages.selectedCategory &&
                            <FormText color="danger"> {componentErrorMessages.selectedCategory}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup className={"mb-3 " + (componentErrorMessages.AirlineId ? 'has-danger' : '')}>
                            <Label>Airline</Label>
                            <SelectListComponent placeholder={'Select airline...'} data={airlines} valueKey='Id' textField='Name' selectValue={AirlineId} onValueChange={(payload) => handleAirlineChange(payload)} />
                            {componentErrorMessages.AirlineId &&
                            <FormText color="danger"> {componentErrorMessages.AirlineId}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup className={"mb-3 " + (componentErrorMessages.FlightNumber ? 'has-danger' : '')}>
                            <Label>Flight Number</Label>
                            <SelectCreatableListComponent promptText={'Create '} data={FlightNumbers} valueKey='FlightNumber' textField='FlightNumber' selectValue={FlightNumber} onValueChange={(payload) => handleFlightChange(payload)}/>
                            {/*<Input type="text" placeholder="" value={FlightNumber} onChange={(event) => handleChange(event, 'FlightNumber')} />*/}
                            {componentErrorMessages.FlightNumber &&
                            <FormText color="danger"> {componentErrorMessages.FlightNumber}</FormText>}
                        </FormGroup>
                    </Col>
                    <Col sm="6">
                    <FormGroup className={"mb-3 " + (componentErrorMessages.StartFlightDate ? 'has-danger' : '')}>
                        <Label>Flight Date</Label>
                      <DatePicker className="date-picker_" showMonthDropdown={true} dropdownMode="select" showYearDropdown={true}	selected={moment(StartFlightDate)} onChange={(payload) => handleDateChange(payload, 'StartFlightDate')}/>
                        {componentErrorMessages.StartFlightDate &&
                        <FormText color="danger"> {componentErrorMessages.StartFlightDate}</FormText>}
                    </FormGroup>
                    </Col>
                    <Col sm="6">
                        <FormGroup className={"mb-3 " + (componentErrorMessages.DepartureAirportId ? 'has-danger' : '')}>
                            <Label>Departure Airport</Label>
                            <SelectListComponent data={airports} valueKey='Id' textField='Name' selectValue={DepartureAirportId} onValueChange={(payload) => handleSelectChange(payload, 'Id', 'DepartureAirportId')}/>
                            {componentErrorMessages.DepartureAirportId &&
                            <FormText color="danger"> {componentErrorMessages.DepartureAirportId}</FormText>}
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default InitiateForm;



// WEBPACK FOOTER //
// ./src/views/iataValidation/initiate-form.js